/**
 *   🕵 Room Filters
 *   Author: David Nuñez
 *   Date: October 2018
 */


/**
 * ==> Apply Array Filter
 *
 * @param data is the array that you want to filter
 * @param key is the first level key (the key's value should be an array of objects)
 * @param innerKey is inside each key's objects.
 * @param values are the values entered by the user.
 */
function applyArrayFilter({data = [], key = '', innerKey = 'id', values = []}) {
  const roomAmenities = data[key].map(obj => (obj[innerKey]));

  const results = values.every(obj => {
    return roomAmenities.includes(obj);
  });

  return results;
}

/**
 * ==> Amenities' Filter
 * @param room type object.
 * @param values type numeric array.
 */
function applyAmenitiesFilter({room = [], values = []}) {

  return applyArrayFilter({data: room, key: 'amenities', values });
}

/**
 * ==> Level's Filter
 *
 * @param room - type Object
 * @param value - type Number
 *
 *  Hard-coded values:
 *  -----------------------------
 *   value  | label
 *  --------|---------------------
 *     0    | "Love Nest Suites"
 *     1    | "Club"
 *     2    | "Luxury"
 *     3    | "Butler"
 *     4    | "All"
 *  -----------------------------|
 *
 * - Notes: @param value has no 's'.
 */

function applyLevelsFilter({room = {}, values = []}) {
  if (values.length === 0) {
    return true;
  }

  if(values.length > 1) {
    return values.includes(room.roomTypeId) || room.loveNest;
  }

  if (values.includes(4)) {
    return true;
  }

  if (values.includes(0)) {
    return room.loveNest;
  }

  return values.includes(room.roomTypeId);

  // if (value === 0) {
  //   return room.loveNest;
  // }

  // if (value === 4) {
  //   return true;
  // }

  // return value === room.roomTypeId;
}

/**
 * ==> Room View's Filter
 * @param room type object.
 * @param values type numeric array.
 */
function applyRoomViewFilter({room = {}, values = []}) {

  return applyArrayFilter({data: room, key: 'views', values });
}

function applyRoomTypeFilter({room = {}, values = []}) {

  return applyArrayFilter({data: room, key: 'roomTypes', values});
}

/**
 * 🚀 How to use it:
 *
 *   const results = rooms.filter(room => {
 *
 *     return [
 *       applyAmenitiesFilter({room, values: [13, 18, 44, 19] }),
 *       applyRoomViewFilter({room, values: [3] }),
 *       applyLevelsFilter({room, value: 10 }),
 *     ].every(result => result);
 *
 *   });
 *
 *   console.log(results);
 */


export {
  applyAmenitiesFilter,
  applyLevelsFilter,
  applyRoomViewFilter,
  applyRoomTypeFilter,
};



// WEBPACK FOOTER //
// ./js/modules/roomFilters.js